import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
type FaqItemProps = {
  question: string;
  answer: string;
};

/** Single accordion FAQ row with accessible expand/collapse. */
export function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [open, setOpen] = useState(false);
  return <div className="overflow-hidden rounded-2xl border border-cream-deep bg-white" data-id="element-123" data-mp="1qyi8rdtnjylc">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sage/50" data-id="element-124" data-mp="1czsfk99yej29">
        <span className="font-serif text-base font-bold text-ink sm:text-lg" data-id="element-125" data-mp="182s5zodway6e">{question}</span>
        <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-sage transition-transform duration-300 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-126" data-mp="2xhyp5g6rycql" />
      </button>
      <AnimatePresence initial={false} data-id="element-127" data-mp="101cn4kagaf3d">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.28,
        ease: 'easeInOut'
      }} data-id="element-128" data-mp="v3b2vw1ag9qb">
            <p className="px-5 pb-5 text-sm leading-relaxed text-ink/70" data-id="element-129" data-mp="14ue4r021ksqn">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}